import React from "react";
import AppButton from 'components/FormsUI/AppButton/appButton';

import govSemel from '../images/Emblem_of_Israel.svg';
import PopulationImmigrationLogo from '../images/logoCustom.png';

const ExpiredSession = (props) => {

    const onClickHandler = () => {
        props.history.push({
            pathname: `/`
        });
    }

    return (<React.Fragment>
        <hr />
          <div className="row">
            <div className="col-md-10 mx-auto">
              <div className="form-group row">
                <div className="col-sm-3">
                  <div
                    className="pull-left"
                    style={{ float: "left" }}
                    id="govLogo">
                    <img src={govSemel} height="70" className="gov" alt="gov"/>
                  </div>
                </div>

                <div
                  className="col-sm-6 d-flex justify-content-center align-items-center"
                  id="mainTitle">
                  <h2 className="PortalTitle">
                    Israel iAPI Portal for Airlines
                  </h2>
                </div>
                <div className="col-sm-3" id="popImigrationLogo">
                  <img alt="Population"
                    src={PopulationImmigrationLogo}
                    style={{ float: "right" }}
                    className="center"
                    height="70"
                  />
                </div>
              </div>
            </div>
          </div>
          <hr />
        <div className="flex-container">
            <div className="uploadRow">
                <div style={{ textAlign: 'center' }}><h1>Your session is Expired</h1></div>
                <AppButton id="signInBtn" size="lg" action={onClickHandler} label="Sign in" isBlock={true}></AppButton>
            </div>
        </div>
    </React.Fragment>
    )
}

export default ExpiredSession;